import { DeviationType } from './enums';

export class MonthlySettings {
  monthlyDays: number[];
  monthlyWorkingDays: number[];
  deviation: number;
  deviationType: DeviationType;
}
